import React, { memo } from 'react';
import classNames from 'classnames';

import FoldoutItem from '@/components/autocomplete/components/FoldoutItem';
import Spinner from '@/components/spinner/Spinner';

import type { FoldoutProps } from '@/components/autocomplete/types';

const Foldout = ({
	nested,
	options = [],
	optionFlagKey,
	optionIconKey,
	optionSectionBodyKey,
	optionSectionKey,
	optionTitleKey,
	optionSubTitleKey,
	optionDescriptionKey,
	handleItem,
	loading,
}: FoldoutProps) => (
	<>
		{loading && <Spinner />}
		{!loading &&
			options.map((item, index) => (
				<div key={index} className={classNames('section', { nested })}>
					{nested ? (
						<>
							{optionSectionKey && item[optionSectionKey] && (
								<h5 className="section-title">{item[optionSectionKey]}</h5>
							)}
							{optionSectionBodyKey &&
								Array.isArray(item[optionSectionBodyKey]) &&
								item[optionSectionBodyKey].map(
									(nestedItem: any, nestedIndex: number) => (
										<FoldoutItem
											key={nestedIndex}
											item={nestedItem}
											optionFlagKey={optionFlagKey}
											optionIconKey={optionIconKey}
											optionTitleKey={optionTitleKey}
											optionSubTitleKey={optionSubTitleKey}
											optionDescriptionKey={optionDescriptionKey}
											handleItem={handleItem}
										/>
									),
								)}
						</>
					) : (
						<FoldoutItem
							item={item}
							optionFlagKey={optionFlagKey}
							optionIconKey={optionIconKey}
							optionTitleKey={optionTitleKey}
							optionSubTitleKey={optionSubTitleKey}
							optionDescriptionKey={optionDescriptionKey}
							handleItem={handleItem}
						/>
					)}
				</div>
			))}
	</>
);

export default memo(Foldout);
